import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { useHistory } from "react-router-dom";
import { Button, Col, Row, Form, Table ,Image} from "react-bootstrap";
import SelectFilter from "../../../reusableComponents/selectFilter";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import moment from "moment";
import BasicPagination from "../../../Pagination/Pagination";
import { SortComponent } from "../../../reusableComponents/SortAndFilterComponent/SortComponent";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import isEmpty from "../../../../store/validation/is-Empty";
import {
  get_all_departmental_money,
  get_all_departmental_money_data,
} from "../../../../store/actions/SuperAdminActions/superAdminWalletAction";
import { SmallLoader } from "../../../Loader/SmallLoader";
import { SuperAdminDepartmentalWalletFilter } from "./SuperAdminDepartmentalWalletFilter";
// Animations

import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";
import NoContent from "../../../reusableComponents/NoContentComponent";

const zoomAnimation = keyframes`${zoomIn}`;

const ZoomDiv = styled.div`
  animation: 1s ${zoomAnimation};
`;

// End Animations

function SuperAdminDepartmentalWallet(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const token = props.auth.user.accessToken;
  const [dateQuery, setDateQuery] = useState({
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });

  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);

  const handleBatchChange = (pageNo) => {
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const onDateChangeHandler = (data, type) => {
    setDateQuery(data);
  };

  /*********************************
   * @DESC TOTAL AMOUNT WALLET
   ********************************/
  const [walletData, setWalletData] = useState({});
  const [walletMoneyData, setWalletMoneyData] = useState([]);
  useEffect(() => {
    dispatch(get_all_departmental_money(token, "SP101"));
    dispatch(
      get_all_departmental_money_data(
        token,
        dateQuery.startDate,
        dateQuery.endDate
      )
    );
  }, []);

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      dispatch(
        get_all_departmental_money_data(
          token,
          dateQuery.startDate,
          dateQuery.endDate
        )
      );
    }
  }, [dateQuery]);

  useEffect(() => {
    if (!isEmpty(props.getWalletBalanceData)) {
      setWalletData(props.getWalletBalanceData);
    }
  }, [props.getWalletBalanceData]);

  useEffect(() => {
    if (!isEmpty(props.getWalletMoneyData)) {
      setWalletMoneyData(props.getWalletMoneyData);
    }
  }, [props.getWalletMoneyData]);

  const [addReason, setAddReason] = useState("All");
  const [addDepartmentalCode, setDepartmentalCode] = useState("All");
  // const [selectDate, setSelectDate] = useState("");
  const [filter, showFilter] = useState(false);
  const [stateOne, setStateOne] = useState({
    search: "",
    anchorEl: null,
    restaurantReverse: "",
    showFilter: false,
    addReasonText: "All",
    addDepartmentalCodeText: "All",
  });

  /*********************************
   * @DESC Search Bar Action
   *********************************/
  const onSearchChange = (e) => {
    setStateOne({
      ...stateOne,
      search: e.target.value,
    });
  };
  const [state, setState] = useState({
    showSearch: false,
  });
  const onFilterSave = (e) => {
    setStateOne({
      ...stateOne,
      addReasonText: addReason,
      addDepartmentalCodeText: addDepartmentalCode,
      // addSelectDateText: selectDate,
    });
    showFilter(!filter);
  };

  const onChangeAddReason = (e) => {
    setAddReason(e.target.value);
  };
  const onChangeDepartmentType = (e) => {
    setDepartmentalCode(e.target.value);
  };

  /*********************************
   * @DESC SORT FILTER ACTION
   *********************************/
  const handleClick = (event) => {
    setStateOne({
      ...stateOne,
      anchorEl: event.currentTarget,
    });
  };

  const handleCloseOne = () => {
    setStateOne({
      ...stateOne,
      anchorEl: null,
    });
  };

  const handleSelect = (value) => () => {
    setStateOne({
      ...stateOne,
      restaurantReverse: value,
      anchorEl: false,
    });
  };

  /*****************************************
   * @DESC Download Button Action
   ****************************************/
  const downloadData = {
    headers: [
      { label: "Transaction Id", key: "transactionId" },
      { label: "Department Code", key: "departmentcode" },
      { label: "Reason", key: "reason" },
      { label: "Comments", key: "comments" },
      { label: "Request Date & Time", key: "requestDateTime" },
      { label: "Amount", key: "amount" },
      { label: "Status", key: "status" },
    ],
    data: walletMoneyData.map((ele) => {
      return {
        transactionId: ele?._id,
        departmentcode: ele?.departmentalCode,
        reason: ele?.reason,
        comments: ele?.message,
        requestDateTime: `${moment(ele?.createdAt).format("ll")}`,
        amount: ele?.amount,
        status: ele?.status,
      };
    }),
  };

  let filterData = walletMoneyData;
  if (
    stateOne.restaurantReverse === "" &&
    stateOne.addDepartmentalCodeText === "All" &&
    stateOne.addReasonText === "All"
  ) {
    filterData = walletMoneyData;
  }
  if (stateOne.addDepartmentalCodeText !== "All") {
    filterData = filterData.filter((data) => {
      if (data.departmentalCode === stateOne.addDepartmentalCodeText) {
        return data;
      } else {
        return false;
      }
    });
  }
  if (stateOne.addReasonText !== "All") {
    filterData = filterData.filter((data) => {
      if (data.status === stateOne.addReasonText) {
        return data;
      } else {
        return false;
      }
    });
  }
  if (stateOne.restaurantReverse === "A-Z") {
    filterData = walletMoneyData.sort((a, b) => {
      if (a?.amount < b?.amount) return -1;
      if (a?.amount > b?.amount) return 1;
      return 0;
    });
  } else if (stateOne.restaurantReverse === "Z-A") {
    filterData = walletMoneyData.sort((a, b) => {
      if (a?.amount < b?.amount) return 1;
      if (a?.amount > b?.amount) return -1;
      return 0;
    });
  }
  if (stateOne.search) {
    let search = new RegExp(stateOne.search, "i");
    filterData = walletMoneyData.filter((getall) => {
      if (search.test(getall?.departmentalCode)) {
        return getall;
      } else if (search.test(getall?.reason)) {
        return getall;
      } else if (search.test(getall?.amount)) {
        return getall;
      } else {
        return false;
      }
    });
  }

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">Departmental Wallet</div>
                <div>
                  <div className="d-flex align-items-center pt-4">
                    <Button
                      variant="outline-danger"
                      className="btn-md px-5"
                      onClick={() => {
                        history.push("/superadmin/departmentwallet/add");
                      }}
                    >
                      Add Money to Wallet
                    </Button>
                  </div>
                </div>
              </div>
              <Row>
                <div className="d-flex align-items-center justify-content-between">
                  <Image
                    onClick={() =>
                      // this.setState({ showSearch: !this.state.showSearch })
                      setState({
                        ...state,
                        showSearch: !state.showSearch,
                      })
                    }
                    alt="filter"
                    title="filter"
                    width="80px"
                    src={require("../../../../assets/images/iconButton/newsearchicon.svg")}
                  />
                  <SortComponent
                    handleClick={handleClick}
                    anchorEl={stateOne.anchorEl}
                    handleClose={handleCloseOne}
                    selectClick={(data) => handleSelect(data)}
                  />
                  <div
                    className="f10-400"
                    align="center"
                    onClick={() => showFilter(!filter)}
                  >
                    <img
                        src={require("../../../../assets/images/iconButton/filterbtn.svg")}
                        width="80px"
                      />
                    <br />
                  </div>
                  <CSVDownloader
                    filename={"Departmental Wallet"}
                    headers={downloadData.headers}
                    data={downloadData.data}
                  />
                </div>
              </Row>
              {state.showSearch && (
                  <div className="mb-3">
                    <ZoomDiv>
                      <>
                        <br />
                        <Form.Control
                    type="text"
                    placeholder="Search"
                    name="search"
                    onChange={onSearchChange}
                    value={stateOne.search}
                    className="amSearch"
                  />
                      </>
                    </ZoomDiv>
                  </div>
                )}
                <hr />
              <div className="row mt-4 mx-2" style={{justifyContent:"space-between"}}>
                  <div className="mr-3 d-flex">
                    <SelectFilter onDateChange={onDateChangeHandler} />
                  </div>
                  <div className="d-flex main-component-itemsforsellement">
                    <div className="mr-3 p-2"
                      style={{ background: "white", borderRadius: "50%" }} >
                      <img
                        src={require("../../../../assets/images/superadmin/earnings.png")}
                        width="45px"
                        className="mx-2"
                      />
                    </div>
                    <div>
                      <div className="f18-700 d-flex align-items-center">
                        ₹{" "}
                        {props?.auth?.secondary_loader ? (
                          <Loader
                            type="Puff"
                            color="#00BFFF"
                            height={25}
                            width={25}
                          />
                        ) : walletData?.balance ? (
                          (walletData?.balance).toFixed(2)
                        ) : (
                          "0"
                        )}
                      </div>
                      <div className="f14-400">Wallet amount</div>
                    </div>
                  </div>
              </div>
              <div>
                <SuperAdminDepartmentalWalletFilter
                  filter={filter}
                  addReason={addReason}
                  addDepartmentalCode={addDepartmentalCode}
                  onChangeDepartmentType={(e) => onChangeDepartmentType(e)}
                  onChangeAddReason={(e) => onChangeAddReason(e)}
                  showFilter={() => showFilter(!filter)}
                  onFilterSave={onFilterSave}
                />
                <div className="col-12 p-0 user-table-reusable-superadmin">
                  <Table className="HideShowTable enMinWidth900">
                    <thead>
                      <tr className="super_admin_all_users_table_head">
                        <td style={{ width: "17%" }} className="f12-400">
                          Transaction ID
                        </td>
                        <td style={{ width: "15%" }} className="f12-400">
                          Department Code
                        </td>
                        <td style={{ width: "15%" }} className="f12-400">
                          Add Reason
                        </td>
                        <td style={{ width: "17%" }} className="f12-400">
                          Comments
                        </td>
                        <td style={{ width: "15%" }} className="f12-400">
                          Date & Time
                        </td>
                        <td style={{ width: "10%" }} className="f12-400">
                          Amount
                        </td>
                        <td style={{ width: "11%" }} className="f12-400">
                          Status
                        </td>
                      </tr>
                    </thead>
                    {props.auth.secondary_loader ? (
                      <SmallLoader />
                    ) : (
                      !isEmpty(filterData) ?
                      filterData.slice(start, end).map((data, index) => {
                        return (
                          <React.Fragment key={index}>
                            <tbody>
                              <tr
                                // className="super_admin_all_users_table_body"
                                style={{
                                  lineBreak: "anywhere",
                                  backgroundColor: "#FFFFFF",
                                  borderRadius: "10px",
                                  boxShadow: "0px 3px 6px #00000014",
                                  padding: "10px 0px",
                                }}
                              >
                                <td
                                  style={{ width: "17%" }}
                                  className="f12-500"
                                >
                                  {data._id}
                                </td>
                                <td
                                  style={{ width: "15%" }}
                                  className="f12-500"
                                >
                                  {data.departmentalCode}
                                </td>
                                <td
                                  style={{ width: "15%" }}
                                  className="f12-500"
                                >
                                  {data.reason}
                                </td>
                                <td
                                  style={{ width: "17%" }}
                                  className="f12-500"
                                >
                                  {data.message}
                                </td>
                                <td
                                  style={{ width: "15%" }}
                                  className="f12-500"
                                >
                                  {moment(data.createdAt).format(
                                    "Do MMM, YYYY"
                                  )}{" "}
                                  <br />
                                  {moment(data.createdAt).format("hh:mm A")}
                                </td>
                                <td
                                  style={{ width: "10%" }}
                                  className="f12-500"
                                >
                                  ₹ {data.amount}
                                </td>
                                <td
                                  style={{ width: "11%" }}
                                  className="f12-500"
                                >
                                  {data.status === "APPROVED" ? (
                                    <div className="badge badge-success px-3 py-2" style={{borderRadius:"20px"}}>
                                      Success
                                    </div>
                                  ) : (
                                    <div className="badge badge-warning px-3 py-2" style={{borderRadius:"20px"}}>
                                    {data?.status}
                                  </div>
                                  
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </React.Fragment>
                        );
                      }):<NoContent/>
                    )}
                  </Table>
                </div>
                {stateOne.search !== "" ? (
                  ""
                ) : (
                  <div className="row">
                    <div className="col-12">
                      {filterData.length !== 0 ? (
                        <BasicPagination
                          totalRecords={filterData.length}
                          limit={10}
                          batch={page}
                          onBatchChange={(e) => handleBatchChange(e)}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

SuperAdminDepartmentalWallet.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  get_all_departmental_money: PropTypes.func.isRequired,
  get_all_departmental_money_data: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  getWalletBalanceData: state.superAdminWallet.get_all_departmental_money,
  getWalletMoneyData: state.superAdminWallet.get_all_departmental_money_data,
});

export default connect(mapStateToProps, {
  get_all_departmental_money,
  get_all_departmental_money_data,
})(withRouter(SuperAdminDepartmentalWallet));
